import $ from 'jquery';
import bindEvent from '../../scripts/util/bindEvent';
import isElement from '../../scripts/util/isElement';
/*
import isViewport from '../../scripts/util/window/isViewport';
import {tablet} from '../../scripts/util/window/isViewport';
*/
import checkKey from '../../scripts/util/event/checkKey';
import {forEach} from 'ramda';
import 'malihu-custom-scrollbar-plugin';
import isMobile from 'ismobilejs';
import addClass from '../../scripts/util/DOM/addClass';
import qs from '../../scripts/util/DOM/qs';
import qsa from '../../scripts/util/DOM/qsa';

const selectors = {
	el: '.js-select',
	body: '.js-body',
	native: '.js-select-native',
	current: '.js-select-current',
	list: '.js-select-list',
	item: '.js-select-item',
	nativeMobile: '.js-select-will-native'
};

const classes = {
	open: 'select_state_open',
	selected: 'select__item_state_selected',
	active: 'select__text_state_active',
	native: 'select_native'
};

const scrollSettings = {
	theme: 'custom',
	scrollInertia: 0
};

const el = () => document.querySelectorAll(selectors.el);
const $scroller = $(selectors.list);

const setValue = item => {
	const selected = item.querySelector(`.${classes.selected}`);
	if (selected) {
		const current = item.querySelector(selectors.current);
		const select = item.querySelector(selectors.native);
		const value = selected.dataset.value;
		const text = selected.textContent;

		current.textContent = text;
		current.classList.add(classes.active);
		select.value = value;
	} else {
		return;
	}
};

const onKeyPress = e => {
	if (checkKey(e)) {
		const select = document.querySelector(`.${classes.open}`);
		if (select) {
			select.classList.remove(classes.open);
		}
	}
};

const onClick = e => {
	const target = e.currentTarget;
	const isOpen = target.classList.contains(classes.open);
	if (isOpen) {
		target.classList.remove(classes.open);
	} else {
		forEach(item => item.classList.remove(classes.open))(el());
		target.classList.add(classes.open);
	}
};

const closeIfOutside = e => {
	const target = e.target;
	const select = document.querySelector(`.${classes.open}`);
	const isEl = target.closest(selectors.el);
	if (!isEl && select) {
		select.classList.remove(classes.open);
	}
};



const onSelect = e => {
	const target = e.target;
	const select = target.closest(selectors.el);
	const selectNative = select.querySelector(selectors.native);
	const selected = select.querySelector(`.${classes.selected}`);

	if (selected) {
		selected.classList.remove(classes.selected);
	}
	/*
	if (isViewport(tablet)) {
		select.classList.remove(classes.open);
	}
	*/
	target.classList.add(classes.selected);
	setValue(select);
	selectNative.dispatchEvent(new CustomEvent('change'));
};


const setHandlers = () => {
	bindEvent(selectors.item, 'click', onSelect);
	bindEvent(selectors.el, 'click', onClick);
	document.addEventListener('keydown', onKeyPress);
	window.addEventListener('click', closeIfOutside);
};

const toggleStateMobileByChange = e => {
	const target = e.currentTarget;
	const value = target.value;
	const option = target.querySelector(`[value="${value}"]`);
	// const select = qs(selectors.nativeMobile);
	qs(selectors.current).innerHTML = option.innerHTML;
	$(selectors.current).addClass('select__text_state_active');
	// select.classList.remove(classes.open);
};

const addNativeClass = addClass(classes.native);

const changeSelectsState = forEach(addNativeClass);

const renderNativeSelect = () => {
	changeSelectsState(qsa(selectors.nativeMobile));
	bindEvent(selectors.native, 'change', toggleStateMobileByChange);
};

const render = () => {
	if (isElement(selectors.el)) {
		$scroller.mCustomScrollbar(scrollSettings);
		forEach(setValue)(el());
		setHandlers();
		if (isMobile.any) {
			renderNativeSelect();
		}
	}
};

export default render;
